@if (apartment$() | async; as apartment) {
  <div class="p-6">

    <h1 class="font-bold text-3xl">{{ apartment.name }}</h1>
    <div class="flex flex-row justify-between">
      <div class="max-w-2xl">
        <div class="grid grid-cols-2 gap-y-6">
          <app-labeled label="Id" [value]="apartment.id"/>
          <app-labeled label="Status" [value]="apartment.status"></app-labeled>

          <app-labeled label="Last updated" [value]="apartment.lastUpdated | date"></app-labeled>
          <app-labeled label="End date" [value]="apartment.endDate | date"></app-labeled>
        </div>
      </div>
    </div>

    <h2 class="mt-12 text-xl font-medium">Eligibility</h2>
    <p-table [value]="apartment.unitTypes">
      <ng-template pTemplate="header">
        <tr>
          <td>Unit</td>
          <td>Min income</td>
          <td>Max income</td>
          <td>Asset limit</td>
          <td>Household size</td>
          <td>Monthly rent</td>
          <td>Estimated savings</td>
          <td>Available units</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-unitType [cTypedTableRow]="apartment.unitTypes">
        <tr>
          <td>{{ unitType.unitType }}</td>
          <td>{{ unitType.minIncome }}</td>
          <td>{{ unitType.maxIncome }}</td>
          <td>{{ unitType.assetLimit }}</td>
          <td>{{ unitType.householdSize }}</td>
          <td>{{ unitType.monthlyRent }}</td>
          <td>{{ unitType.estimatedSavings }}</td>
          <td>{{ unitType.unitsAvailable }}</td>
        </tr>
      </ng-template>
    </p-table>

    <div class="mt-12 space-y-6">
      <div class="flex items-center justify-between">
        <h2 class="text-xl font-medium">Images</h2>
        <button
          pButton
          type="button"
          label="Refresh photos"
          icon="pi pi-refresh"
          (click)="refreshPhotos()"
          [disabled]="loadingPhotos()"
          severity="secondary"
        ></button>
      </div>

      <div *ngIf="loadingPhotos()" class="flex items-center gap-2 text-sm text-slate-600">
        <i class="pi pi-spin pi-spinner"></i>
        Loading photos…
      </div>

      <div *ngIf="detail() as detail" class="space-y-4">
        <div class="flex flex-wrap items-center justify-between gap-2">
          <span class="text-sm text-slate-500">{{ detail.photos.length }} photo(s). Select main image and reorder as needed.</span>
        </div>

        <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          <div
            *ngFor="let photo of detail.photos; let idx = index"
            class="flex flex-col bg-white border border-slate-100 rounded-xl shadow-sm overflow-hidden"
          >
            <div class="relative h-44 bg-slate-100">
              <img [src]="photo.src" alt="Lottery photo" class="w-full h-full object-cover" />
              <span
                *ngIf="photo.src === detail.mainPhoto.src"
                class="absolute top-2 left-2 bg-blue-600 text-white text-xs font-semibold px-2 py-0.5 rounded"
              >
                Main
              </span>
            </div>
            <div class="p-3 flex flex-col gap-3">
              <p class="text-sm text-slate-700 break-words">
                {{ photo.alt || 'No description provided' }}
              </p>
              <div class="flex flex-wrap gap-2">
                <button
                  pButton
                  type="button"
                  label="Set main"
                  (click)="setAsMain(photo.src)"
                  [disabled]="actionInFlight() || photo.src === detail.mainPhoto.src"
                  size="small"
                  class="flex-1"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-arrow-up"
                  (click)="movePhoto(idx, 'up')"
                  [disabled]="actionInFlight() || idx === 0"
                  severity="secondary"
                  size="small"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-arrow-down"
                  (click)="movePhoto(idx, 'down')"
                  [disabled]="actionInFlight() || idx === detail.photos.length - 1"
                  severity="secondary"
                  size="small"
                ></button>
                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  (click)="deletePhoto(photo.src)"
                  [disabled]="actionInFlight()"
                  severity="danger"
                  size="small"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="border border-slate-200 bg-white rounded-xl p-4 space-y-3">
        <h3 class="text-lg font-semibold text-slate-700">Upload a new image</h3>
        <div class="space-y-2">
          <label class="block text-sm font-medium">Image file</label>
          <input
            type="file"
            accept="image/*"
            (change)="onFileSelected($event)"
            class="block w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-slate-700"
          />
          <p *ngIf="uploadFileName()" class="text-xs text-slate-500">
            Selected file: {{ uploadFileName() }}
          </p>
          <p *ngIf="uploadPreparing()" class="text-xs text-slate-500">
            Requesting a secure upload link…
          </p>
          <p *ngIf="uploadTarget() && !uploadPreparing()" class="text-xs text-slate-500">
            Ready to upload directly to S3.
          </p>
        </div>
        <button
          pButton
          type="button"
          label="Upload photo"
          icon="pi pi-upload"
          (click)="uploadPhoto()"
          [disabled]="actionInFlight() || uploadPreparing() || !uploadFile() || !uploadTarget()"
        ></button>
      </div>
    </div>
  </div>
}
